import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  CircularProgress,
} from "@mui/material";
import { get } from "src/services/httpClient.service";
import { authenticationService } from "src/services";

const CommissionWalletTransactions = () => {
 
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const lcoId = JSON.parse(localStorage.getItem("selectedLCO"))?.id;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    setLoading(true);
    try {
    let response;

    if (franchiseId) {
      response = await get(
        `${process.env.REACT_APP_BASE_API_URL}/api/commission-wallet/vendor/${vendorId}/franchise/${franchiseId}/findAll`
      );
    } else {
      response = await get(
        `${process.env.REACT_APP_BASE_API_URL}/api/commission-wallet/vendor/${vendorId}/findAll`
      );
    }

    console.log("Commission wallet response:", response);

    setTransactions(
      Array.isArray(response?.data) ? response.data : []
    );
  } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatAmount = (value) => {
    if (value === null || value === undefined) return "-";
    return Number(value).toFixed(2);
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Box p={2}>
      <Typography variant="h6" mb={2}>
        Commission Wallet Transactions
      </Typography>

      <Paper  elevation={3}
  sx={{
    backgroundColor: "transparent",
  }}>
        <TableContainer   sx={{
          
    height: 400, // Fixed table height
    maxHeight: 400,
  }}
>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Transaction ID</TableCell>
                <TableCell>Transaction Type</TableCell>
                <TableCell align="right">Before Wallet</TableCell>
                <TableCell align="right">Commission</TableCell>
                <TableCell align="right">After Wallet</TableCell>
                <TableCell>Package</TableCell>
                <TableCell align="right">Package Amount</TableCell>
                <TableCell>Operator</TableCell>
                <TableCell>Operator Type</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Created Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : transactions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    No Records Found
                  </TableCell>
                </TableRow>
              ) : (
                transactions
                  .slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  .map((row, index) => (
                    <TableRow key={row.id} hover>
                      <TableCell>
                        {page * rowsPerPage + index + 1}
                      </TableCell>

                      <TableCell>{row.id}</TableCell>

                      <TableCell>{row.transactionType}</TableCell>

                      <TableCell align="right">
                        {formatAmount(row.beforeWallet)}
                      </TableCell>

                      <TableCell align="right">
                        {formatAmount(row.commissionAmount)}
                      </TableCell>

                      <TableCell align="right">
                        {formatAmount(row.afterWallet)}
                      </TableCell>

                      <TableCell>{row.packageName || "-"}</TableCell>

                      <TableCell align="right">
                        {formatAmount(row.packageAmount)}
                      </TableCell>

                      <TableCell>{row.operatorName}</TableCell>

                      <TableCell>{row.operatorType}</TableCell>

                      <TableCell>{row.createdBy}</TableCell>

                      <TableCell>
                        {formatDate(row.createdDate)}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={transactions.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5,10, 25, 50, 100]}
        />
      </Paper>
    </Box>
  );
};

export default CommissionWalletTransactions;
